var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAllZem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6664 3.64196L13.3338 1.33618H2.67008L1.33748 3.64196L0.00488281 5.95363L8.00243 15.2239L16 5.95363L14.6664 3.64196Z",
    fill: "#A0CEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67008 5.95362H0.00488281L1.33748 3.64196L2.67008 1.33618L4.00366 3.64196L5.33134 5.95362H2.67008Z",
    fill: "#5AABFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00249 5.95264H10.6687L9.33509 10.5917L8.00249 15.2268L6.66989 10.5917L5.33435 5.95264H8.00249Z",
    fill: "#439FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6701 5.95264H5.33137L7.99755 15.2229L0 5.95264H2.6701Z",
    fill: "#2E94FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3338 5.95264H16L8.00244 15.2229L10.6686 5.95264H13.3338Z",
    fill: "#2E94FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00249 5.95364H5.33435L6.66989 3.64197L8.00249 1.33325L9.33509 3.64197L10.6677 5.95069L8.00249 5.95364Z",
    fill: "#5AABFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3338 5.95364H10.6676L12.0002 3.64197L13.3328 1.33325L14.6654 3.64197L15.998 5.95069L13.3338 5.95364Z",
    fill: "#5AABFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6676 1.33618H13.3338L12.0012 3.64196L10.6676 5.95362L9.33504 3.64196L8.00244 1.33618H10.6676Z",
    fill: "#8CC4FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33229 1.33618H7.99847L6.66882 3.64196L5.33229 5.95362L4.00264 3.64196L2.67004 1.33618H5.33229Z",
    fill: "#8CC4FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAllZem);
export default __webpack_public_path__ + "static/media/ic_all_zem.d01f5b7a7096e472c7b9dac2908eb1a1.svg";
export { ForwardRef as ReactComponent };